module.exports = __webpack_public_path__ + "img/icon-couponList.48f7829f.png";